module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-bonus.814a5e77.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-bonus.png
// module id = 2536
// module chunks = 11